import React from 'react'

import { FieldProps, FurnishingString } from '../../../../../../../@types/types'
import { SCREEN_FLAT_SHARE_ROOM_PROPERTIES, SCREENS } from '../../../../../../../services/domain/wizardScreens'
import { AbstractScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'

const screen = SCREENS[SCREEN_FLAT_SHARE_ROOM_PROPERTIES]

const Furnishing: React.FC<FieldProps<AbstractScreenValidationResult>> = ({ insertionData, onChange }) => {
  return (
    <div className='margin-top-l'>
      <ChipOptionField
        id='furnishing'
        propertyName='furnishing'
        option={insertionData.furnishing}
        options={FurnishingString}
        translation='wizard.screen.flatShareRoomProperties.furnishing.'
        labelTranslationKey='wizard.screen.flatShareRoomProperties.labels.furnishing'
        onChange={(value) => onChange({ screen: screen.name, property: 'furnishing' }, value)}
      />
    </div>
  )
}

export default Furnishing
